import * as Yup from "yup";

export function initialValues(clientDB) {
  return {
    title: clientDB?.title || "",
    miniature: clientDB?.miniature || "",
    file: null,
    description: clientDB?.description || "",
    url: clientDB?.url || "",
    client: clientDB?.client || "",
  };
}

export function validationSchema() {
  return Yup.object({
    title: Yup.string().required(true),
    description: Yup.string().required(true),
    url: Yup.string().required(true),
    client: Yup.string().required(true),
  });
}
